import * as React from "react";

import { cn } from "@/core/utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "flex field-sizing-content min-h-16 w-full rounded-md border border-input bg-card px-3 py-2 text-base leading-[1.55] text-foreground transition-colors outline-none placeholder:text-muted-foreground hover:border-ink-300 focus-visible:border-teal-600 focus-visible:ring-3 focus-visible:ring-teal-100 disabled:cursor-not-allowed disabled:bg-muted disabled:opacity-50 aria-invalid:border-danger aria-invalid:ring-3 aria-invalid:ring-danger/20 md:text-sm",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
